import { AnalyticsIcon, SettingsIcon } from '@/components/icons';
import { SideBarRouteOption } from '@/types';
import { CheckIcon } from '@mantine/core';
import { FaCheckToSlot, FaMoneyCheckDollar } from 'react-icons/fa6';
import { IoDocumentOutline } from 'react-icons/io5';

const insuranceRoutes: SideBarRouteOption[] = [
   {
      name: 'Analytics',
      path: '/insurance',
      icon: AnalyticsIcon,
   },
   {
      name: 'History',
      path: '/insurance/history',
      icon: CheckIcon,
      hasSubRoutes: true,
      routes: [
         {
            name: 'Eligibility Checks',
            path: '/insurance/history/eligibility-checks',
            icon: CheckIcon,
         },
         {
            name: 'Approvals',
            path: '/insurance/history/approvals',
            icon: CheckIcon,
         },
         {
            name: 'Claims',
            path: '/insurance/history/claims',
            icon: CheckIcon,
         },
         {
            name: 'Billing',
            path: '/insurance/history/billing',
            icon: CheckIcon,
         },
      ],
   },
   {
      name: 'Approval Requests',
      path: '/insurance/approval-requests',
      icon: FaCheckToSlot,
   },
   {
      name: 'Bills',
      path: '/insurance/bills',
      icon: FaMoneyCheckDollar,
   },
   {
      name: 'Reports',
      path: '/insurance/reports',
      icon: IoDocumentOutline,
   },
   {
      name: 'Insurance Settings',
      path: '/insurance/settings',
      icon: SettingsIcon,
   },
];

export default insuranceRoutes;
